module.exports = __webpack_public_path__ + "media/images/health-40acfc3a1da75288846edcade1ccc976.svg";